import { createContext, useMemo, useState } from "react";
import { Color } from "../models/theme";

interface State {
  isAnimating: boolean;
  color: Color;
}

interface TimelineAnimateScrollContextValue {
  state: State;
  setIsAnimating: (state: State) => void;
}

export const TimelineAnimateScrollContext =
  createContext<TimelineAnimateScrollContextValue>(
    {} as TimelineAnimateScrollContextValue
  );

export const TimelineAnimateScrollProvider: React.FC = ({ children }) => {
  const [state, setIsAnimating] = useState<State>({
    isAnimating: false,
    color: "blueDark",
  });

  const value = useMemo(() => ({ state, setIsAnimating }), [state]);

  return (
    <TimelineAnimateScrollContext.Provider value={value}>
      {children}
    </TimelineAnimateScrollContext.Provider>
  );
};
